import { $$, $e } from './utils';

$$('.tablesorter')?.forEach((table) => {
  const columns = table.tHead?.querySelectorAll('.sortable');
  if (!columns?.length) return;

  let current;
  let direction = 'ASC';
  const columnSettings = [...columns].map((column) => {
    const index = [...column.parentElement.children].findIndex((child) => child === column);
    const marker = $e('i', { className: 'fas fa-sort' });
    const span = $e('span', { innerHTML: column.innerHTML, style: { flexGrow: '1' } });
    const cntr = $e(
      'span',
      { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5em' } },
      span,
      marker,
    );
    column.replaceChildren(cntr);
    column.style.cursor = 'pointer';
    column.style.userSelect = 'none';
    return { column, marker, index };
  });

  table.tHead.addEventListener('click', (ev) => {
    const targetColumn = ev.target.closest('.sortable');
    const target = targetColumn && columnSettings.find(({ column }) => column === targetColumn);
    if (!target) return;

    ev.preventDefault();
    if (current && current !== target) {
      current.column.classList.remove('!bg-red-400');
      current.marker.className = 'fas fa-sort';
      direction = 'ASC';
    } else if (current === target) {
      direction = direction === 'ASC' ? 'DESC' : 'ASC';
    }
    target.column.classList.add('!bg-red-400');
    target.marker.className = `fas fa-sort-${direction === 'ASC' ? 'up' : 'down'}`;
    [...table.tBodies].forEach((tbody) => {
      const rows = [...tbody.children];
      rows.sort((a, b) => {
        const ak = sortkey(a.children.item(target.index));
        const bk = sortkey(b.children.item(target.index));
        const r = ak > bk ? 1 : ak < bk ? -1 : 0;
        return direction === 'DESC' ? -r : r;
      });
      tbody.replaceChildren(...rows);
    });
    current = target;
  });
  table.tHead.querySelector('.default-sort')?.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
});

function sortkey(cell) {
  return (cell && (cell.dataset.sort || cell?.textContent)) || '';
}
